// extracted by mini-css-extract-plugin
module.exports = {"placeholderHidden":"_bdf54150","placeholder":"_c7182e1a","small":"_dbf56ee6","medium":"_63f45884","large":"_aa122c44","isNarrow":"_769b5c74"};